export default __webpack_public_path__ + "static/media/cumin-seed-icon.c7f28bb1.svg";